import { Injectable } from '@angular/core';
import { UsersApiService } from '@epicuro-next/data/users';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { loadUsers, upsertUserEntities } from './user-entities.actions';
import { selectLoadedUsersFactory } from './user-entities.selectors';

@Injectable()
export class UserEntitiesEffects {
  constructor(
    private actions$: Actions,
    private userService: UsersApiService,
    private store: Store,
  ) {}

  public loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUsers),
      mergeMap((action) => {
        if (action.strategy === 'lazy') {
          return this.filterOutAlreadyLoadedUsers(action.ids).pipe(
            map((ids) => ({ ...action, ids })),
          );
        }
        return of(action);
      }),
      mergeMap(({ ids }) =>
        this.userService.getUsersByExternalId(ids).pipe(
          map((users) =>
            upsertUserEntities({
              entities: users.map((user) => ({
                userExternalId: user.externalId,
                user: { ...user, profilePictureUrl: user.imageLink }, // api gap
                loading: false,
              })),
            }),
          ),
          catchError(() =>
            of(
              upsertUserEntities({
                entities: ids.map((id) => ({
                  userExternalId: id,
                  loading: false,
                })),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  private filterOutAlreadyLoadedUsers(ids: string[]) {
    return this.store.pipe(
      select(selectLoadedUsersFactory(ids)),
      map((users) =>
        ids.filter((id) => !users.find((u) => id === u?.userExternalId)),
      ),
    );
  }
}
